import React from "react";
import { Form, InputNumber, Checkbox, Select, Button } from "antd";
import styled from "styled-components";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

interface Option {
  label: string;
  value: string;
}

interface OfficeSpace {
  name: string | null;
  finition: string | null;
  installation_cablage: boolean;
  bureau_surface_min: number | null;
  bureau_surface_max: number | null;
}

interface Props {
  form: any;
  formData: any;
  setFormData: any;
}

const typeDeProjetOptions: Record<string, Option[]> = {
  bureaux: [
    { label: "Coworking", value: "coworking" },
    { label: "Salles de conférences", value: "salles de conférences" },
    { label: "Bureaux individuels", value: "bureaux individuels" },
    { label: "Open space", value: "open space" },
  ],
};

const BureauxFormList: React.FC<Props> = ({ form, formData, setFormData }) => {
  const handleSurfaceChange = (index: number, field: string, value: number | null) => {
    const currentPrices = form.getFieldValue("bureaux_prices") || [];
    const bureaux = form.getFieldValue("bureaux") || [];
    const currentPrice = currentPrices[index] || {};
    
    if (index >= currentPrices.length) return;
    
    const updatedPrices = [...currentPrices];
    
    if (field === "bureau_surface_min") {
      // If unit price is available, update total price
      if (currentPrice.prix_vente_unitaire_min && value) {
        updatedPrices[index] = {
          ...updatedPrices[index],
          prix_vente_min: Math.round(currentPrice.prix_vente_unitaire_min * value)
        };
      }
    } else if (field === "bureau_surface_max") {
      // If unit price is available, update total price
      if (currentPrice.prix_vente_unitaire_max && value) {
        updatedPrices[index] = {
          ...updatedPrices[index],
          prix_vente_max: Math.round(currentPrice.prix_vente_unitaire_max * value)
        };
      }
    }
    
    form.setFieldsValue({ bureaux_prices: updatedPrices });
    setFormData((prev: any) => ({
      ...prev,
      bureaux_prices: updatedPrices,
    }));
  };
  return (
    <>
      <Form.List name="bureaux">
        {(fields, { add, remove }) => {
          if (fields.length === 0) {
            add({
              name: null,
              finition: null,
              installation_cablage: false,
              bureau_surface_min: null,
              bureau_surface_max: null,
            });
          }
          return (
            <>
              <ScrollableTableWrapper>
                <table
                  style={{
                    minWidth: "1000px",
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "fixed",
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          ...headerStyle,
                          width: "50px",
                          borderBottom: "none",
                          borderLeft: "none",
                          borderTop: "none",
                          backgroundColor: "#fff",
                        }}
                      >
                        <Button
                          color="primary"
                          variant="solid"
                          onClick={() => {
                            add({
                              name: null,
                              finition: null,
                              installation_cablage: false,
                              bureau_surface_min: null,
                              bureau_surface_max: null,
                            });
                          }}
                          icon={<PlusOutlined />}
                        />
                      </th>
                      <th style={{ ...headerStyle, borderBottom: "none" }}>
                        Type
                      </th>
                      <th style={{ ...headerStyle, borderBottom: "none" }}>
                        Finition
                      </th>
                      <th style={{ ...headerStyle, borderBottom: "none" }}>
                        Installation Câblage
                      </th>
                      <th
                        style={{ ...headerStyle, borderBottom: "none" }}
                        colSpan={2}
                      >
                        Surface Bureau (m²)
                      </th>
                    </tr>
                    <tr>
                      <th
                        style={{
                          ...subHeaderStyle,
                          borderTop: "none",
                          backgroundColor: "#fff",
                        }}
                      ></th>
                      <th style={{ ...subHeaderStyle, borderTop: "none" }}></th>
                      <th style={{ ...subHeaderStyle, borderTop: "none" }}></th>
                      <th style={{ ...subHeaderStyle, borderTop: "none" }}></th>
                      <th style={subHeaderStyle}>Min</th>
                      <th style={subHeaderStyle}>Max</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fields.map(({ key, name, ...restField }) => {
                      const currentValue = form.getFieldValue([
                        "bureaux",
                        name,
                        "name",
                      ]);
                      return (
                        <tr key={key}>
                          <td style={cellStyle}>
                            <Button
                              variant="solid"
                              color="danger"
                              disabled={fields.length === 1}
                              onClick={() => {
                                remove(name);

                                // After removing apartment, update the prices array
                                setTimeout(() => {
                                  const currentApartments =
                                    form.getFieldValue("bureaux") || [];
                                  const currentPrices =
                                    form.getFieldValue("bureaux_prices") || [];

                                  // Remove the corresponding price entry
                                  const newPrices = currentPrices.filter(
                                    (_: any, index: number) => index !== name
                                  );

                                  form.setFieldsValue({
                                    bureaux_prices: newPrices,
                                  });
                                  setFormData((prev: any) => ({
                                    ...prev,
                                    bureaux_prices: newPrices,
                                  }));
                                }, 0); // Use setTimeout to ensure the apartment is removed first
                              }}
                              icon={<MinusCircleOutlined />}
                            />
                          </td>
                          <td style={cellStyle}>
                            <Form.Item
                              style={{ marginBottom: 0 }}
                              {...restField}
                              name={[name, "name"]}
                              rules={[
                                {
                                  required: true,message:""}
                              ]}
                            >
                              <Select
                                style={{ width: "100%" }}
                                placeholder="Select type"
                                value={currentValue}
                                options={typeDeProjetOptions.bureaux.map(
                                  (option) => {
                                    const currentOffices =
                                      form.getFieldValue("bureaux") || [];
                                    const isDisabled = currentOffices.some(
                                      (o: OfficeSpace, idx: number) =>
                                        idx !== name && o.name === option.value
                                    );
                                    return { ...option, disabled: isDisabled };
                                  }
                                )}
                                onChange={(value) => {
                                  if (!currentValue) {
                                    form.setFields([
                                      {
                                        name: ["bureaux", name, "name"],
                                        value,
                                      },
                                    ]);
                                  }
                                }}
                              />
                            </Form.Item>
                          </td>
                          <td style={cellStyle}>
                            <Form.Item
                              style={{ marginBottom: 0 }}
                              {...restField}
                              name={[name, "finition"]}
                            >
                              <Select
                                style={{ width: "100%" }}
                                placeholder="Finition"
                              >
                                <Select.Option value="brut">Brut</Select.Option>
                                <Select.Option value="semi fini">
                                  Semi fini
                                </Select.Option>
                                <Select.Option value="fini">Fini</Select.Option>
                              </Select>
                            </Form.Item>
                          </td>
                          <td style={cellStyle}>
                            <Form.Item
                              style={{ marginBottom: 0 }}
                              {...restField}
                              name={[name, "installation_cablage"]}
                              valuePropName="checked"
                            >
                              <Checkbox />
                            </Form.Item>
                          </td>
                          <td style={cellStyle}>
                            <Form.Item
                              style={{ marginBottom: 0 }}
                              {...restField}
                              name={[name, "bureau_surface_min"]}
                              rules={[
                                { required: true, message: "" },
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    const max = getFieldValue([
                                      "bureaux",
                                      name,
                                      "bureau_surface_max",
                                    ]);
                                    if (!value || !max || value <= max) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(new Error(""));
                                  },
                                }),
                              ]}
                            >
                              <InputNumber onChange={(value) =>
                                  handleSurfaceChange(
                                    name,
                                    "bureau_surface_min",
                                    typeof value === "string"
                                      ? parseFloat(value)
                                      : value
                                  )
                                } style={{ width: "100%" }} />
                            </Form.Item>
                          </td>
                          <td style={cellStyle}>
                            <Form.Item
                              style={{ marginBottom: 0 }}
                              {...restField}
                              name={[name, "bureau_surface_max"]}
                              rules={[
                                { required: true, message: "" },
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    const min = getFieldValue([
                                      "bureaux",
                                      name,
                                      "bureau_surface_min",
                                    ]);
                                    if (!value || !min || value >= min) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error("")
                                    );
                                  },
                                }),
                              ]}
                            >
                              <InputNumber onChange={(value) =>
                                  handleSurfaceChange(
                                    name,
                                    "bureau_surface_max",
                                    typeof value === "string"
                                      ? parseFloat(value)
                                      : value
                                  )
                                } style={{ width: "100%" }} />
                            </Form.Item>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </ScrollableTableWrapper>
            </>
          );
        }}
      </Form.List>
    </>
  );
};

const headerStyle = {
  border: "2px solid #42005a",
  padding: "3px",
  fontSize: "14px",
  fontWeight: "bold",
  color: "#42005a",
  backgroundColor: "#eeedf0",
  width: "150px",
};

const subHeaderStyle = {
  ...headerStyle,
  fontSize: "12px",
  borderLeft: "none",
};

const cellStyle = {
  border: "2px solid #42005a",
  padding: "3px",
  textAlign: "center" as const,
};

const ScrollableTableWrapper = styled.div`
  overflow-x: auto;
  padding-bottom: 8px;
  margin-top: 16px;

  &::-webkit-scrollbar {
    height: 16px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #42005a;
    border-radius: 4px;
    &:hover {
      background-color: #603570;
    }
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    border-radius: 4px;
  }

  scrollbar-width: thin;
  scrollbar-color: #42005a #f1f1f1;
`;

export default BureauxFormList;
